<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="warehouseLocationForm commonFormStyles">
            <HeaderNav
                header-title="库位表单"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <ul class="formList">
                <li>
                    <van-field
                        disabled
                        label="库位编号"
                        placeholder="自动生成"
                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                        v-model="formData.GridCode"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="仓库编号"
                        placeholder="请选择仓库"
                        :disabled="isMaintenance"
                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                        v-model="formData.StockCode"
                        @click="selectWarehouse"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="仓库名称"
                        placeholder="请选择仓库"
                        :disabled="isMaintenance"
                        :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                        v-model="formData.StockName"
                        @click="selectWarehouse"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="货架编号"
                        placeholder="请选择货架编号"
                        :disabled="isMaintenance"
                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                        v-model="formData.ShelfCode"
                        @click="openSelectPopuo('ShelfCode')"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="库位类别"
                        placeholder="请选择库位类别"
                        :disabled="isMaintenance"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.GridCategoryName"
                        @click="openSelectPopuo('GridCategory')"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        label="库位名称"
                        placeholder="请输入库位名称"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.GridName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        label="库存存放最大量"
                        placeholder="请输入库存存放最大量"
                        :left-icon="require('@/assets/images/icons/icon_31@2x.png')"
                        v-model="formData.VolumeMax"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        label="库位号"
                        placeholder="请输入库位号"
                        :left-icon="require('@/assets/images/icons/icon_18@2x.png')"
                        v-model="formData.GridNo"
                    ></van-field>
                </li>
                <template v-if="formData.GridCategory != 6">
                    <template v-for="(item, index) in formData.materials">
                        <li :key="`material_${index}`">
                            <div class="inputAngBtn">
                                <van-field
                                    readonly
                                    label="物料代码"
                                    placeholder="请选择物料代码"
                                    :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                                    v-model="item.MaterialCode"
                                    @click="selectMaterials(index)"
                                >
                                    <template #button>
                                        <van-button
                                            plain
                                            size="small"
                                            type="primary"
                                            v-if="showAddBtn(index)"
                                            @click.stop="addMaterial"
                                        >
                                            <van-icon name="plus"></van-icon>
                                        </van-button>
                                        <van-button
                                            plain
                                            size="small"
                                            type="danger"
                                            v-if="(formData.VolumeCurrent || 0) == 0 || item.isAdd == true"
                                            @click.stop="deleteMaterial(index)"
                                        >
                                            <van-icon name="minus"></van-icon>
                                        </van-button>
                                    </template>
                                </van-field>
                            </div>
                            <van-field
                                readonly
                                label="短描述"
                                placeholder="请选择物料代码"
                                :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                v-model="item.MaterialShortName"
                                @click="selectMaterials(index)"
                            ></van-field>
                        </li>
                    </template>
                </template>
                <li>
                    <van-field
                        disabled
                        label="最近一次盘点时间"
                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                        v-model="formData.LastCheckTime"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        label="其他"
                        type="textarea"
                        :rows="2"
                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                        v-model="formData.Remarks"
                    ></van-field>
                </li>
            </ul>
            <footer class="currencyFooterStyle">
                <button class="confirm" @click="saveWarehouseLocation">
                    保存
                </button>
            </footer>
            <van-popup v-model="showSelectPopuo" position="bottom" :style="{ height: '40%' }">
                <van-picker
                    show-toolbar
                    title="请选择"
                    :columns="selectList"
                    :value-key="valueKey"
                    @confirm="confirmSelect"
                    @cancel="showSelectPopuo = false"
                ></van-picker>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    // 库位表单
    name: 'warehouse-location-form',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (['purchaseInventoryForm', 'warehouseLocationAdministration'].includes(from.name)) {
                vm.backPathName = from.name;
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === this.backPathName) {
            this.$store.commit('noKeepAlive', 'warehouse-location-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            backPathName: '',
            formData: {
                Id: '',
                GridCode: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                ShelfCode: '',
                GridCategory: '',
                GridCategoryName: '',
                GridName: '',
                GridNo: '',
                VolumeMax: null,
                Remarks: '',
                materials: [{
                    MaterialCode: '',
                    MaterialName: '',
                    MaterialShortName: '',
                }],
            },
            shelfCodeList: [],
            gridCategoryList: [],
            selectList: [],
            valueKey: '',
            warehouseLocationCategory: [],
            showSelectPopuo: false,
            popuoType: '',
            materialIndex: null,
            isMaintenance: false,
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.warehouseData) {
            this.formData.StockCode = this.$route.params.warehouseData[0].stock_code;
            this.formData.StockId = this.$route.params.warehouseData[0].id;
            this.formData.StockName = this.$route.params.warehouseData[0].stock_name;
        }
        if (this.$route.params.materialData) {
            this.formData.materials[this.materialIndex].MaterialShortName = this.$route.params.materialData[0].MaterialShortName;
            this.formData.materials[this.materialIndex].MaterialCode = this.$route.params.materialData[0].MaterialCode;
            this.formData.materials[this.materialIndex].MaterialName = this.$route.params.materialData[0].MaterialName;
            this.formData.materials[this.materialIndex].isAdd = true;
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
            });
        },

        async initpage() {
            this.shelfCodeList = Array.from({ length: 26 }, (_, i) => String.fromCharCode('A'.charCodeAt(0) + i));
            this.gridCategoryList = await this.getDictionaryData();
            const type = this.$route.params.type;
            if (type === 'maintenance') {
                const id = this.$route.params.data.id;
                this.formData = await this.getWarehouseLocationRequrst(id);
                if ((this.formData.materials || []).length === 0) {
                    this.formData.materials.push({
                        MaterialCode: '',
                        MaterialName: '',
                        MaterialShortName: '',
                    });
                }
                this.isMaintenance = true;
            } else if (type === 'new') {
                const storemanStock = await this.getStoremanStock();
                if (storemanStock) {
                    this.formData.StockCode = storemanStock.StockCode;
                    this.formData.StockId = storemanStock.Id;
                    this.formData.StockName = storemanStock.StockName;
                }
            }
        },

        // 选择仓库
        selectWarehouse() {
            if (this.isMaintenance) { return; }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库',
                    sourcePath: 'warehouseLocationForm',
                    listCode: 'choose_stock',
                    callbackDataKey: 'warehouseData',
                    requestUrl: '/basicplatform/tabledata?choose_type=storeman',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '仓库编号',
                        code: 'stock_no',
                        icon: 'icon_34@2x',
                    }, {
                        name: '仓库类别',
                        code: 'stock_category_name',
                        icon: 'icon_13@2x',
                    }, {
                        name: '库位数量',
                        code: 'grid_count',
                        icon: 'icon_16@2x',
                    }, {
                        name: '主要存放',
                        code: 'main_storage',
                        icon: 'icon_32@2x',
                    }, {
                        name: '管理单位',
                        code: 'manage_org_name',
                        icon: 'icon_4@2x',
                    }, {
                        name: '管理部门',
                        code: 'manage_dept_name',
                        icon: 'icon_29@2x',
                    }, {
                        name: '仓库保管员',
                        code: 'storeman_name',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },

        async openSelectPopuo(type) {
            if (this.isMaintenance) { return; }
            this.popuoType = type;
            if (type === 'ShelfCode') {
                this.showSelectPopuo = true;
                this.selectList = this.shelfCodeList;
                this.valueKey = '';
            } else if (type === 'GridCategory') {
                if (this.formData.materials[0].MaterialCode !== '' || this.formData.materials.length > 1 ) {
                    this.$toast('请先删除所有物料！');
                } else {
                    this.showSelectPopuo = true;
                    this.selectList = this.gridCategoryList;
                    this.valueKey = 'Name';
                }
            }
        },

        confirmSelect(val, index) {
            if (this.popuoType === 'ShelfCode') {
                this.formData.ShelfCode = val;
            } else if (this.popuoType === 'GridCategory') {
                this.formData.GridCategory = this.selectList[index].Code;
                this.formData.GridCategoryName = this.selectList[index].Name;
                this.formData.materials = [{
                    MaterialCode: '',
                    MaterialName: '',
                    MaterialShortName: '',
                }];
            }
            this.showSelectPopuo = false;
        },

        showAddBtn(index) {
            let showBtn = false;
            if ([0, 1, 4].includes(Number(this.formData.GridCategory))) {
                if ((this.formData.materials || []).length - 1 === index) {
                    showBtn = true;
                }
            }
            return showBtn;
        },

        addMaterial() {
            this.formData.materials.push({
                MaterialCode: '',
                MaterialName: '',
                MaterialShortName: '',
            });
        },

        deleteMaterial(index) {
            if (this.formData.materials.length === 1) {
                this.formData.materials[index].MaterialCode = '';
                this.formData.materials[index].MaterialShortName = '';
                this.formData.materials[index].MaterialName = '';
            } else {
                this.formData.materials.splice(index, 1);
            }
        },

        selectMaterials(index) {
            if (this.formData.GridCategory === '') {
                this.$toast('请先选择库位类别！');
                return;
            }
            this.materialIndex = index;
            this.$router.isBack = 2;
            let MaterialCategory = null;
            if (this.formData.GridCategory === '0') {
                MaterialCategory = 0;
            } else if (this.formData.GridCategory === '1') {
                MaterialCategory = 2;
            } else {
                MaterialCategory = 1;
            }
            this.$router.replace({
                name: 'selectMaterials',
                params: {
                    sourcePath: 'warehouseLocationForm',
                    requestUrl: '/procurement/catalog_manager/choose_material_page',
                    requestType: 'post',
                    requestData: {
                        MaterialCategory,
                    },
                    callbackDataKey: 'materialData',
                    relationKey: 'Id',
                    headerList: [{
                        name: '物料代码',
                        code: 'MaterialCode',
                        width: '35%',
                    }, {
                        name: '短描述',
                        code: 'MaterialShortName',
                    }],
                },
            });
        },

        async saveWarehouseLocation() {
            const res = await this.saveWarehouseLocationRequrst(this.formData);
            if (res) {
                this.$toast.success('保存成功');
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.backPathName,
                    params: {
                        saveCallback: true,
                    },
                });
            }
        },

        // 获取字典数据
        getDictionaryData() {
            return this.$axios.$get('/interfaceApi/procurement/tbcode/getbytype/grid_category');
        },

        getStoremanStock() {
            return this.$axios.$get('/interfaceApi/procurement/stock/storeman_stock');
        },

        getWarehouseLocationRequrst(id) {
            return this.$axios.$get(`/interfaceApi/procurement/stock_grid/get/${id}`);
        },

        saveWarehouseLocationRequrst(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/stock_grid/save', requestData);
        },
    },
};
</script>
<style lang="stylus">
.warehouseLocationForm
    .formList
        li
            .inputAngBtn
                .van-cell
                    padding-bottom 0
                    border-bottom none
                    .van-field__control
                        text-align left
                &+.van-cell
                    .van-field__control
                        text-align left
</style>
